export default __webpack_public_path__ + "static/media/logo.051c1967.svg";